import { ReactNode } from 'react'

export function RouteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="route-wrap">
      <div className="route-line" />
      {children}
    </div>
  )
}

export function RouteSection({
  children,
  mark,
  className = '',
  markTop = 36,
  id,
}: {
  children: ReactNode
  mark: string | number
  className?: string
  markTop?: number
  id?: string
}) {
  return (
    <section id={id} className={`page-section ${className}`}>
      <div className="route-mark" style={{ top: markTop }}>
        {mark}
      </div>
      {children}
    </section>
  )
}
